import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import { getRecents } from '../../api/recent';

import { REQUEST } from '../../constants/request';

export const fetchRecents = createAsyncThunk(
  'recent/fetchRecents',
  async (arg, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getRecents({
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const { recent } = getState();

      return recent.loading !== REQUEST.pending;
    },
  },
);

export const RecentSlice = createSlice({
  name: 'recent',
  initialState: {
    recent: {
      threadChannels: [],
      tags: [],
      mentions: [],
      userId: '',
      threads: [],
      rebuzzChannels: [],
      searches: [],
    },
  },
  loading: REQUEST.idle,
  requestId: undefined,
  error: null,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchRecents.pending, (state, { meta }) => {
      const { requestId } = meta;
      state.error = undefined;
      state.loading = REQUEST.pending;
      state.requestId = requestId;
    });
    builder.addCase(fetchRecents.fulfilled, (state, { meta, payload }) => {
      if (
        state.loading === REQUEST.pending &&
        state.requestId === meta.requestId
      ) {
        state.recent = { ...state.recent, ...payload };
      }
      state.loading = REQUEST.idle;
      state.requestId = undefined;
    });
    builder.addCase(fetchRecents.rejected, (state, { payload }) => {
      state.loading = REQUEST.idle;
      state.requestId = undefined;
      state.error = payload;
    });
  },
});

export default RecentSlice.reducer;

export const selectorGetRecentTags = state => state.recent.recent;
export const selectorGetRecentLoadingState = state => state.recent.loading;
